"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._CloseIcon = _CloseIcon;
exports.CloseIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseSvg = require("./base-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _CloseIcon(props, ref) {
  return (/*#__PURE__*/_react.default.createElement(_baseSvg.BaseSVG, _extends({
      ref: ref
    }, props), function (fillColor) {
      return (/*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#clip0)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M9.53342 8.11993C9.5179 8.10445 9.50558 8.08606 9.49718 8.06581C9.48878 8.04556 9.48445 8.02386 9.48445 8.00193C9.48445 7.98001 9.48878 7.9583 9.49718 7.93805C9.50558 7.91781 9.5179 7.89941 9.53342 7.88393L15.7088 1.70927C15.8963 1.52149 16.0015 1.26692 16.0013 1.00156C16.0011 0.736194 15.8955 0.481773 15.7078 0.294265C15.52 0.106757 15.2654 0.0015217 15 0.00170923C14.7347 0.00189677 14.4803 0.107492 14.2928 0.295265L8.11808 6.46727C8.1026 6.48279 8.08421 6.4951 8.06396 6.5035C8.04371 6.51191 8.02201 6.51623 8.00008 6.51623C7.97816 6.51623 7.95646 6.51191 7.93621 6.5035C7.91596 6.4951 7.89757 6.48279 7.88208 6.46727L1.70742 0.295265C1.61457 0.202377 1.50434 0.128685 1.38302 0.0783977C1.26169 0.0281102 1.13165 0.00221158 1.00032 0.00218062C0.735081 0.00211811 0.480681 0.107424 0.293085 0.294932C0.105488 0.48244 6.25399e-05 0.736791 2.78157e-08 1.00203C-6.24843e-05 1.26727 0.105243 1.52167 0.292751 1.70927L6.46675 7.88393C6.48227 7.89941 6.49459 7.91781 6.50299 7.93805C6.51139 7.9583 6.51572 7.98001 6.51572 8.00193C6.51572 8.02386 6.51139 8.04556 6.50299 8.06581C6.49459 8.08606 6.48227 8.10445 6.46675 8.11993L0.292751 14.2953C0.199907 14.3882 0.126267 14.4984 0.0760367 14.6198C0.0258064 14.7411 -3.0925e-05 14.8712 2.78157e-08 15.0025C6.25399e-05 15.2677 0.105488 15.5221 0.293085 15.7096C0.385973 15.8024 0.496239 15.8761 0.617587 15.9263C0.738934 15.9765 0.868987 16.0024 1.00032 16.0023C1.26556 16.0023 1.51991 15.8969 1.70742 15.7093L7.88208 9.53393C7.89757 9.51841 7.91596 9.5061 7.93621 9.49769C7.95646 9.48929 7.97816 9.48497 8.00008 9.48497C8.02201 9.48497 8.04371 9.48929 8.06396 9.49769C8.08421 9.5061 8.1026 9.51841 8.11808 9.53393L14.2928 15.7093C14.4803 15.8969 14.7346 16.0023 14.9999 16.0023C15.2651 16.0024 15.5195 15.8971 15.7071 15.7096C15.8947 15.5221 16.0001 15.2677 16.0002 15.0025C16.0002 14.7373 15.8949 14.4829 15.7074 14.2953L9.53342 8.11993Z",
          fill: fillColor
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "clip0"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 0H16V16H0V0Z",
          fill: "white"
        }))))
      );
    })
  );
}

_CloseIcon.displayName = 'CloseIcon';

var CloseIcon = _react.default.forwardRef(_CloseIcon);

exports.CloseIcon = CloseIcon;
CloseIcon.defaultProps = _baseSvg.BaseSVG.defaultProps;
CloseIcon.propTypes = _baseSvg.BaseSVG.propTypes;
CloseIcon.displayName = 'CloseIcon';